import { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function EyeSlashIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M4.52 5.935L1.394 2.808l1.414-1.414 19.799 19.799-1.414 1.414-3.31-3.31A10.949 10.949 0 0 1 12 21c-5.392 0-9.878-3.88-10.818-9a10.982 10.982 0 0 1 3.34-6.066zm10.237 10.238l-1.464-1.464a3 3 0 0 1-4.001-4.001L7.828 9.243a5 5 0 0 0 6.929 6.929zM7.974 3.76C9.221 3.27 10.58 3 12 3c5.392 0 9.878 3.88 10.819 9a10.947 10.947 0 0 1-2.012 4.593l-3.86-3.86a5 5 0 0 0-5.68-5.68L7.974 3.761z"
      />
    </BaseIcon>
  )
}
